import { getApiErrorFieldCode, getApiErrorReason, getApiErrorStatus } from "../../lib/api/apiError";

const MESSAGES = {
  CODE_MISSING: "Enter the code for every channel shown above.",
  CODE_INVALID: "Incorrect code. Please check and try again.",
  SESSION_EXPIRED: "That code expired. Resend to get a new one.",
  NOT_ALLOWED: "That is not allowed right now.",
  CONTACT_TAKEN:
    "That contact is now registered to another account. Please contact support.",
  UNAUTHORIZED: "Please sign in again to continue.",
  NETWORK: "No connection. Check your internet and try again.",
  UNKNOWN: "Something went wrong. Please try again.",
};

const RESTART = ["SESSION_EXPIRED"];

const classify = (error) => {
  if (!error?.response) return "NETWORK";

  const status = getApiErrorStatus(error);
  const code = String(getApiErrorFieldCode(error) ?? "").toLowerCase();

  if (code === "invalid.request.data") return "CODE_MISSING";
  if (code === "invalid.otp") return "CODE_INVALID";
  if (code === "not.found") return "SESSION_EXPIRED";
  if (code === "not.allowed") return "NOT_ALLOWED";
  if (code === "identity.already.exists") return "CONTACT_TAKEN";
  if (code === "missing.jwt" || code === "invalid.token") return "UNAUTHORIZED";

  if (status === 401) return "UNAUTHORIZED";
  if (status === 403) return "NOT_ALLOWED";
  if (status === 404) return "SESSION_EXPIRED";
  if (status === 409) return "CONTACT_TAKEN";

  return "UNKNOWN";
};

export const parseAccountError = (error) => {
  const kind = classify(error);
  const reason = getApiErrorReason(error);
  const prefersReason = kind === "NOT_ALLOWED" || kind === "CONTACT_TAKEN";

  return {
    kind,
    message: (prefersReason && reason) || MESSAGES[kind],
    reason,
    needsRestart: RESTART.includes(kind),
    clearsSession: kind === "UNAUTHORIZED",
  };
};

export default parseAccountError;
